module.exports = __webpack_public_path__ + "img/dog3.5a963db7.png";